"use strict"
const format = require("../../helpers/format");
const relations = require('./../relations');

const getObject = (data, outputs) => {
    let obj = {};
    for (let i = 0; i < outputs.length; i++) {
        obj[outputs[i].name] = data[i];
    }
    return obj;
}

const output_object = (data, config, with_relations = true) => {
    let res = [];
    if (Array.isArray(data) && data.length > 0) {
        for (let idx = 0; idx < config.length; idx++) {
            res[idx] = [];
            if (!config[idx].type || config[idx].type == "data" || config[idx].type == "file" || config[idx].type == "get_missing_payment_processor_wallet_data" || config[idx].type == "address_validate" ) {
                for (let row of data[idx]) {
                    let obj = {};
                    let idxField = 0;
                    for (let field of config[idx].fields) {
                        obj[field.name] = format(field.type, row[idxField], field.format ? field.format : null);
                        idxField++;
                    }
                    res[idx].push(obj);
                }
            } else {
                switch (config[idx].type) {
                    case 'token':
                        res[idx].push({ 'token': data[idx][0], 'urlToken':data[idx][1] });
                        break;
                    case 'email':
                        res[idx].push({ 'total_email_sended': data[idx][0] });
                        break;
                    case 'sms':
                        res[idx].push({ 'total_sms_sended': data[idx][0] });
                        break;
                    case 'merchantTransaction':
                        res[idx].push(data[idx]);
                        break
                    default:
                        break;
                }
            }
        }
        if (with_relations) {
            return relations(res, config);
        }
    }
    return getObject(res, config);
}

module.exports = output_object;